<template lang="pug">
div
  section.faq(v-if="currentPath == '/' || currentPath == '/review'")
    .title-wrap
      span.title-text FAQ
    #accordion
      .tnc-card
        button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc1' aria-expanded='false' aria-controls='tnc1')
          | 1. How do I get free credit RM10 at epicwin?
        #tnc1.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
          .tnc-body
            p
              | Claiming free credit RM10 on EpicWin is easy! All you have to do is sign up for a free account and look for the Welcome Bonus at the Promotions page. You&apos;ll be credited with RM10 once your registration is confirmed. Start your EPIC winning journey today &mdash; spin and get ready to win big!
      .tnc-card
        button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc2' aria-expanded='false' aria-controls='tnc2')
          | 2. What is the best Ewallet Casino in Malaysia to claim free credit?
        #tnc2.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
          .tnc-body
            p
              | EpicWin is the best eWallet casino in Malaysia to claim free credits - if you&apos;re looking for an exciting, secure, and reliable online slot experience, EpicWin is your answer. With our game slot free credit offers, you can start playing right away without having to worry about making any deposits. Claim your free credit now and get ready to start your EPIC winning journey!
      .tnc-card
        button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc3' aria-expanded='false' aria-controls='tnc3')
          | 3. Is it legal to play mobile slot games in Malaysia?
        #tnc3.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
          .tnc-body
            p
              | Yes, playing slot games on EpicWin is perfectly legal in Malaysia. We understand the importance of offering a safe and secure gambling experience to our players, which is why our casino only features verified licensed game providers with legally certified slots. Rest assured that when you play here, your gaming experience is completely secure and safe.
      .tnc-card
        button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc4' aria-expanded='false' aria-controls='tnc4')
          | 4. How do I use my Win88 Wallet?
        #tnc4.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
          .tnc-body
            p
              | EpicWin&rsquo;s Win88 Wallet has been tailored to meet online casino players&rsquo; needs &mdash; from a simple and secure way to deposit funds, to a fast and efficient way to withdraw winnings. To use your Win88 Wallet, simply follow the step-by-step instructions displayed in the EpicWin app. From there, you&rsquo;ll be able to add funds to your account, withdraw them, get game slot free credit offers, and more! With EpicWin, EPIC wins are just a few clicks away!
      .tnc-card
        button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc5' aria-expanded='false' aria-controls='tnc5')
          | 5. How to avail Win88 Wallet Free Credit?
        #tnc5.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
          .tnc-body
            p
              | It&rsquo;s easy! With EpicWin, you can easily avail of the Win88 Wallet Free Credit just by signing up. After signing up, simply head to &lsquo;My Wallet&rsquo; and claim your free credit. Once claimed, you can use this free credit on any game slot of your choice and start playing games for real cash money wins!
      .tnc-card
        button.btn-tnc.collapsed(data-bs-toggle='collapse' data-bs-target='#tnc6' aria-expanded='false' aria-controls='tnc6')
          | 6. How does EpicWin differ from other online casinos in Malaysia?
        #tnc6.collapse(aria-labelledby='headingOne' data-bs-parent='#accordion' style='')
          .tnc-body
            p
              | EpicWin offers a unique experience with exclusive bonus offers and rewards. Our free credit welcome bonus is one of the biggest in the industry, which makes the signup process extremely rewarding. We also have ongoing promotions and VIP rewards that give you an extra edge when playing games. So sign up today and get ready to make some Epic Wins!
  template(v-if="metaData.length > 0")
    .footer-wrap(v-if="metaData[0].en_body")
      .con
        .seo-wrap
          div(v-if="metaData[0].en_item_name" v-html="metaData[0].en_item_name")
          #readMore.d-inline(v-if="showMore")
            div(v-if="metaData[0].en_body" v-html="metaData[0].en_body")
        button#moreBtn.btn-submit(@click="toggleC(1)" v-if="!showMore") + Read More
        button#moreBtn.btn-submit(@click="toggleC(0)" v-if="showMore") - Read Less
  hr
  .menu-footer.mt-3
    div
      ul
        p Information
        li
          router-link(to="/aboutUs") {{$t('ui.aboutus')}}
        li
          router-link(to="/review") {{$tc('ui.review')}}
          //- a(href="https://www.trustpilot.com/review/epicvipclub.com" target="_blank") {{$tc('ui.review')}}
        li
          router-link(to="/news") {{$t('ui.news')}}
        li
          router-link(to="/contactUs") {{$t('ui.contactus')}}
        li
          router-link(to="/followUs") {{$t('ui.follow_us')}}
    div
      ul.text-capitalize
        p Games
        li
          router-link(to="/slot") {{$t('ui.slots')}}
        li
          router-link(to="/live") {{$t('ui.live')}}
        li
          router-link(to="/table") Poker
        li 
          router-link(to="/fish") {{$t('ui.fishing')}}
        li
          router-link(to="/minigame") {{$t('ui.minigames')}}
        li
          router-link(to="/freeplay") {{$t('ui.demoplay')}}

  hr
  .menu-footer.mt-3
    .f-column.d-flex.flex-column
      .title Certification
      .cert-image
        img(src="/new/img/cert/pagcor.webp")
        img(src="/new/img/cert/gaming sosoft.webp")
        img(src="/new/img/cert/itech.webp")
        img(src="/new/img/cert/imga.webp")
        img(src="/new/img/cert/bmm.webp")
    .f-column.d-flex.flex-column
      .title Responsible Gaming
      .d-flex.justify-content-start
        img(src="/new/img/cert/18.webp")
        img(src="/new/img/cert/IG.webp")
        img(src="/new/img/cert/begamble.webp")
  hr
  .menu-footer.mt-3
    .f-column.d-flex.flex-column
      .title Payment Methods
      .payment-footer
        img(src='/new/img/payment/fpx.webp')
        img(src='/new/img/payment/duit now logo copy.webp')
        img(src='/new/img/payment/tng.webp')
        img(src='/new/img/payment/grab pay.webp')
        img(src='/new/img/payment/boost.webp')
        img(src='/new/img/payment/celcom.webp')
        img(src='/new/img/payment/digi.webp')
        img(src='/new/img/payment/maxis.webp')
        //- img(src='/new/img/payment/umobile.webp')
    .f-column.d-flex.flex-column
      .title Security
      .payment-footer
        img.m-0(src='/new/img/security/threat.webp')
        img.m-0(src='/new/img/security/iovation.webp')
  hr
  .provider-logo-wrapper
    p Providers
    img(src='/new/img/footer/EPICWIN-BW.webp')
    img(src='/new/img/footer/megah5.webp')
    img(src='/new/img/footer/pp.webp')
    img(src='/new/img/footer/joker.webp')
    img(src='/new/img/footer/jili.webp')
    img(src='/new/img/footer/JDB bw.webp')
    img(src='/new/img/footer/live22.webp')
  hr
  .menu-footer.mt-3
    .f-column.d-flex.flex-column
      .title Follow Us
      contactUs
    .f-column.d-flex.flex-column
      a(href="https://www.trustpilot.com/review/epicvipclub.com" target="_blank")
        img.h-75.pointer(src='/new/img/footer/trustpilot.webp')
  //- .social-footer
    p Follow Us
    contactUs
  hr
  .copyright.text-center.w-100
    div Copyright EpicWin © 2020 - {{$moment().year() }}. All rights reserved.
</template>
<script>
import contactUs from '@/component/_contactUs.vue'
export default {
  components: {
    contactUs
  },
  props: {
    target: {
      type: String,
      default: ""
    },
  },
  data(){
    return{
      showMore: false,
      feedback: {
        success: true,
        status: ""
      },
      currentPath: "",
      metaData:[]
    }
  },
  metaInfo(){
    if(this.metaData.length> 0){
      return{
        title: this.metaData[0].meta_title || 'EpicWin Malaysia',
        meta:[
          { name: 'description',content: this.metaData[0].meta_desc },
          { name: "keywords", content: this.metaData[0].meta_keywords },
          { name: "author", content: this.metaData[0].meta_author },
          { name: "publisher", content: this.metaData[0].meta_publisher },

          { property: 'og:title', content: this.metaData[0].meta_title },
          { property: 'og:description', content: this.metaData[0].meta_desc },
          
        ],
      }
    }
  },
  watch:{
    $route (to, from){
      this.currentPath = to.path
      this.getSeo()
    }
  },
  mounted(){
    this.currentPath = this.$router.currentRoute.fullPath
    this.getSeo()
  },
  methods:{
    getSeo(){
      this.metaData = []
      var temp = window.location.pathname.split("/")
      var domain_name = window.location.hostname
      // var domain_name = "www.epicwinslots.com";
      // Remove 'www.' if it exists in the hostname
      domain_name = domain_name.startsWith("www.") ? domain_name.slice(4) : domain_name;
      
      if(this.currentPath === '/'){
        var page_name = "home";
      }else if(this.currentPath === '/login'){
        var page_name = "logins"
      }else{
        var page_name = temp[temp.length-1]
      }
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
              $('link[rel="canonical"]').attr('href', this.metaData[0].meta_canonical);
						}
					} else {
						if((typeof response.status) != 'object'){
							// this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
              console.log(response.status)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						// this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            console.log(response.status)
					}
				});
		},
    toggleC(option){
      if(option == 0){
        this.showMore = false
      }else{
        this.showMore = true
      }
    }
  }
}
</script>